const ONLINE_THRESHOLD_MS = 5 * 60 * 1000;

const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value?.toDate === "function") {
    const parsed = value.toDate();
    return Number.isNaN(parsed?.getTime?.()) ? null : parsed;
  }
  if (typeof value?.seconds === "number") {
    const millis = value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6);
    const parsed = new Date(millis);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const getDriverPresence = (isOnlineRaw, lastSeenRaw) => {
  const lastSeenDate = toDate(lastSeenRaw);

  if (typeof isOnlineRaw === "boolean" && !isOnlineRaw) {
    return {
      isOnline: false,
      lastSeenDate,
    };
  }

  if (typeof isOnlineRaw === "boolean" && isOnlineRaw) {
    if (!lastSeenDate) {
      return {
        isOnline: true,
        lastSeenDate: null,
      };
    }
    const isOnline = Date.now() - lastSeenDate.getTime() < ONLINE_THRESHOLD_MS;
    return {
      isOnline,
      lastSeenDate,
    };
  }

  if (!lastSeenDate) {
    return {
      isOnline: false,
      lastSeenDate: null,
    };
  }

  const isOnline = Date.now() - lastSeenDate.getTime() < ONLINE_THRESHOLD_MS;
  return {
    isOnline,
    lastSeenDate,
  };
};

export const formatLastSeenDateTime = (lastSeenRaw) => {
  const lastSeenDate = toDate(lastSeenRaw);
  if (!lastSeenDate) return "";
  return lastSeenDate.toLocaleString();
};
